export const teams = [
    {
        'teamID': 1,
        'teamName': 'Tiger Team',
        'teamKey': 'teamTiger',
        'teamColor': '#FF6358'
    },
    {
        'teamID': 2,
        'teamName': 'Lemon Team',
        'teamKey': 'teamLemon',
        'teamColor': '#F7C62F'
    },
    {
        'teamID': 3,
        'teamName': 'Organic Team',
        'teamKey': 'teamOrganic',
        'teamColor': '#55AB1D'
    },
    {
        'teamID': 4,
        'teamName': 'Ocean Team',
        'teamKey': 'teamOcean',
        'teamColor': '#28B4C8'
    }
];